import { render } from "./OrderDetailProductsSummary.vue?vue&type=template&id=3f687885&scoped=true&ts=true"
import script from "./OrderDetailProductsSummary.vue?vue&type=script&lang=ts"
export * from "./OrderDetailProductsSummary.vue?vue&type=script&lang=ts"

import "./OrderDetailProductsSummary.vue?vue&type=style&index=0&id=3f687885&lang=sass&scoped=true"

import exportComponent from "D:\\workspace\\com.xiansheng\\MiezzGitPull\\Miezz\\Miezz.Web.Entry\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f687885"]])

export default __exports__